import { ABP, eLayoutType } from '@abp/ng.core';

export const FLOWPAY_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/faturamento/flowpay',
    name: 'FlowPay',
    parentName: 'Faturamento',
    iconClass: 'fas fa-file-code',
    layout: eLayoutType.application,
    order: 0,
  },
];
